import { ref } from "vue";
import appApi from "@/services/api";
import { exceptionRequestMsg, showToast } from "@/assets/js/util";

const useReportes = () => {
  const listaCotizaciones = ref([]);
  const searchingData = ref(false);
  const dataCargada = ref(false);
  const noRecords = ref(false);

  const fetchInitialReportes = async () => {
    try {
      const response = await appApi().get(`reportes`);
      listaCotizaciones.value = response.data;
      dataCargada.value = true;
    } catch (e) {
      console.log(e);
    }
  };

  const getData = async (page = 1) => {
    dataCargada.value = false;
    try {
      searchingData.value = true;
      const response = await appApi().get(`reportes?page=${page}`);
      listaCotizaciones.value = response.data;
      dataCargada.value = true;
    } catch (e) {
      console.log(e);
      exceptionRequestMsg(e);
    } finally {
      searchingData.value = false;
    }
  };

  const searchData = async () => {
    dataCargada.value = false;
    const form = document.getElementById("formReporte");
    const formData = new FormData(form);
    try {
      searchingData.value = true;
      const response = await appApi().post(`reportes/search`, formData);
      console.log(response.data.data);
      response.data.data.length == 0
        ? (noRecords.value = true)
        : (noRecords.value = false);
      listaCotizaciones.value = response.data;
      dataCargada.value = true;
    } catch (e) {
      console.log(e);
      exceptionRequestMsg(e);
    } finally {
      searchingData.value = false;
    }
  };

  return {
    listaCotizaciones,
    fetchInitialReportes,
    getData,
    dataCargada,
    searchingData,
    searchData,
    noRecords,
  };
};

export default useReportes;
